import request from './plugins/request'

// 获取文章列表
export let articleList = () => {
  return request({
    url: '/article/list',
    params:{
      token:localStorage.getItem('token')
    },
    method:'post'
  })
}

// 创建一篇文章
export let creatArticle = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/article/add',
    params: myParams,
    method:'post'
  })
}

// 删除一篇文章
export let deleteArticle = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/article/delete',
    params: myParams,
    method:'post'
  })
}

// 查看一篇文章的详情
export let detailArticle = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/article/detail',
    params: myParams,
    method:'post'
  })
}


// 修改一篇文章的详情
export let updateArticle = (params = {}) => {
  let myParams = Object.assign({token:localStorage.getItem('token')},params);
  return request({
    url: '/article/update',
    params: myParams,
    method:'post'
  })
}
